export default __webpack_public_path__ + "static/img-project-12-0552bb1ced23597726a8e01dd3bf91d9.png";